module.exports = __webpack_public_path__ + "img/user-11.17fbd9e7.jpg";